(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	$('[data-dropdown], #main-menu').each(function () {
		var dropdown = $(this);

		// Add dropdown icons to all dropdown menus
		dropdown.find('li').each(function () {
			var li = $(this);

			if (li.find('ul').length) {
				// Unless it's already added (by WP)
				if (!li.find('> a').find('.icon-dropdown-toggle').length) {
					li.addClass('dropdown').find('> a').append('<span class="icon-dropdown-toggle"></span>');
				}
			}
		});

		// When cliking dropdown togglers
		dropdown.find('.icon-dropdown-toggle').click(function (e) {
			e.preventDefault();

			$(this).parents('li').eq(0).toggleClass('open');
		});

		// AUto-open selected menus
		dropdown.find('li.current-cat, li.current-cat-parent, li.current-cat-ancestor, li.active, li.active-parent, li.active-ancestor').addClass('open');
	});
})();
